import React from 'react';
import authService, { parsePrivilege, parseFunctionality } from '../../services/AuthService';

const showWhenPermission = (functionality, privilege = null) => {
  const f = parseFunctionality(functionality);
  const p = parsePrivilege(privilege);

  return WrappedComponent => ({ ...passThroughProps }) => {
    if (
      !authService.hasPermission({
        functionality: f,
        privilege: p,
      })
    )
      return null;
    return <WrappedComponent {...passThroughProps} />;
  };
};
export default showWhenPermission;

/* Used like this:
export default showWhenPermission('relation','read')(RelationOverviewContainer);
*/
